module.exports = __webpack_public_path__ + "img/煤炭交易大数据平台建设—中国（太原）煤炭交易中心—1-1.dcf5cc4c.jpg";